export const GetDbReferrals = `query GetDbReferrals($companyId: ID!, $userId: ID) {
  getDbReferrals(companyId: $companyId, userId: $userId) {
    acceptedReferrals
    referrals
    __typename
  }
}`;
